import { connect } from 'react-redux';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import ButtonList from '../components/ButtonList';
import { isEqual } from '../utils/string-compare';

class WidgetContainer extends React.Component {
	render() {
		return (
			<Common
				render={({ labels, prefs }) => {
					return (
						<ButtonList
							labels={labels}
							prefs={prefs}
							{...this.props}
						/>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {};

const mapStateToProps = state => {
	const { items, vehicle, requestData } = state;
	const { deviceType } = requestData || 'desktop';
	return {
		items,
		vehicle,
		isMobile: isEqual(deviceType, 'mobile')
	};
};

const mapDispatchToProps = _dispatch => {
	return {};
};

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx